module.exports = __webpack_public_path__ + "static/media/thumbnail.9ce93564.jpg";